import { useTranslation } from 'react-i18next';

import { ImgViewer } from '../img-viewer/img-viewer';
import { ClosePicturesButton, ImageWrap, Row } from './ride-photos.styled';

export const RidePhotos = (props) => {
  const { close, row, cols } = props;
  const { t } = useTranslation();

  /**
   * get photo
   * @param {*} photo
   * @returns
   */
  const getPhoto = (photo) => {
    return row.data?.photos ? row.data.photos[photo] : null;
  };

  const photo1 = getPhoto('photo_1');
  const photo2 = getPhoto('photo_2');
  const photo3 = getPhoto('photo_3');

  if (photo1 === '-' && photo2 === '-' && photo3 === '-') {
    return null;
  }

  return (
    <Row>
      <td colSpan={cols}>
        <ImageWrap className="center">
          {photo1 !== '-' && <ImgViewer images={[photo1]} width={'33%'} height={'300px'} />}
          {photo2 !== '-' && <ImgViewer images={[photo2]} width={'33%'} height={'300px'} />}
          {photo3 !== '-' && <ImgViewer images={[photo3]} width={'33%'} height={'300px'} />}
          <ClosePicturesButton onClick={close}>
            <i className="fa fa-arrow-up" />
            {t('buttons.Скрыть')}
          </ClosePicturesButton>
        </ImageWrap>
      </td>
    </Row>
  );
};
